import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSecurityValidatorApi } from "../../end-points/securityValidator";
import { toast } from "react-toastify";

const initialState = {
  showValidator: false,
  showOverview: false,
  repoPath: "",
  loading: false,
  config_file: "",
  fs_file: ""
}

export const getSecurityValidator = createAsyncThunk(
  "securityValidator/getSecurityValidator", getSecurityValidatorApi
)

export const securityValidatorSlice = createSlice({
  name: "securityValidator",
  initialState,
  reducers: {
    setShowValidator: (state, action) => {
      state.showValidator = action.payload;
      if (action.payload === true) {
        state.showOverview = false;
      }
    },
    setShowOverview: (state, action) => {
      state.showOverview = action.payload;
      if (action.payload === true) {
        state.showValidator = false;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getSecurityValidator.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getSecurityValidator.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.config_file = action.payload.config_file;
      state.fs_file = action.payload.fs_file;
      if(action.payload.success){
        state.showValidator = true;
        state.showOverview = false;
      } else {
        toast.error("Error while attempting to run the security validator")
      }
      state.loading = false;
      console.log("state.config_file", state.config_file);
      console.log("state.fs_file", state.fs_file);
    })
    builder.addCase(getSecurityValidator.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }

})

// Action creators are generated for each case reducer function
export const { setShowValidator, setShowOverview } = securityValidatorSlice.actions;

export default securityValidatorSlice.reducer